import { render, staticRenderFns } from "./ImageTop.vue?vue&type=template&id=565b3fd8&"
import script from "./ImageTop.vue?vue&type=script&lang=js&"
export * from "./ImageTop.vue?vue&type=script&lang=js&"
import style0 from "./ImageTop.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports